import { api } from "./apiClient";

export const auditLogsAPI = {
  getAll: (params = {}) => api.get("/admin/audit-logs", { params }),
};
